
var lang = $('html').attr('lang');
var ajaxLng = (lang == 'cs') ? '' : '/' + lang;
var fd;
var fdArr = {};

$(function () {
    /*
     * Add product
     */
    $(document).on("click", "[data-add-product]", function (e) {
        e.preventDefault();
        var product = $(this).data('add-product');
        var count = $("#product-count-" + product).val();

        var data = {
            action: 'add-product',
            product: product,
            count: count,
        }

        $.ajax({
            url: ajaxLng + '/ajax/basket/',
            data: data,
            type: 'post',
            dataType: "json",
            success: function (response) {
                updateBasketTopInfo(response.totalPrice, response.itemsCount);
                $("#cart-toggle-content-wrapper").html(response.topCartTpl);                
            }
        });
    });
    
    /*Remove product*/
    $(document).on("click", "[data-remove-product]", function (e) {
        e.preventDefault();
        var product = $(this).data('remove-product');
        var data = {
            action: 'remove-product',
            product: product,
        }
        $.ajax({
            url: ajaxLng + '/ajax/basket/',
            data: data,
            type: 'post',
            dataType: "json",
            success: function (response) {
                $('.item-total-price-' + product).closest('.cart-item').fadeOut('slow');
                updateBasketTopInfo(response.totalPrice, response.itemsCount);
                $('#product-row-' + product).hide();
            }
        });

    });



});

/*
 * Update top price and items
 */

function updateBasketTopInfo(totalPrice, itemsCount) {
    $('.data-basket-price').text(totalPrice);
    $('#data-basket-items').text(itemsCount);
}

function updateBasketItemPrice(productId, productPriceTotal, productCountTotal) {
    $('.item-total-price-' + productId).text(productPriceTotal);
    $('.item-total-count-' + productId).val(productCountTotal);//value

}
